import getAffiliateId from '../../utils/get_affiliate_id';

function ModalCreative({ creative, onCloseModal }) {
  const affiliate_id = getAffiliateId();

  return (
    <div className="modal" style={{display: 'block'}}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{creative.name}</h5>
            <button type="button" className="close" onClick={onCloseModal}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="description" dangerouslySetInnerHTML={{__html: creative.description}}></div>
            <div className="creative-image">
              <h3 className="sub-title">Preview</h3>
              <figure className="thumbnail"><img className="img-fluid" src={creative.image} alt={creative.name} /></figure>
            </div>
            <h3 className="sub-title">Code</h3>
            <div className="creative-campaign-code">
              <pre><code>{`<a href="${creative.url}?ref=${affiliate_id}><img src="${creative.image}" alt="${creative.name}" /></a>`}</code></pre>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onCloseModal}>Đóng</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalCreative
